const BLOCKING_TAGS = ['INPUT', 'TEXTAREA', 'SELECT', 'VIDEO', 'AUDIO'];

export const walkToOpenAfterExclusion = (refreshedIds, index, excludedId) => {
  if (refreshedIds.length === 0) {
    return null;
  }
  const nextId = refreshedIds[Math.min(index, refreshedIds.length - 1)];
  return nextId === excludedId ? null : nextId;
};

export const walkShortcutAction = ({
  key,
  repeat,
  altKey,
  ctrlKey,
  metaKey,
  shiftKey,
  tagName,
  role,
  isContentEditable
}) => {
  if (repeat || altKey || ctrlKey || metaKey || shiftKey) {
    return null;
  }
  if (
    BLOCKING_TAGS.includes(tagName) ||
    isContentEditable ||
    role === 'slider'
  ) {
    return null;
  }
  switch (key) {
    case 'ArrowLeft':
      return 'previous';
    case 'ArrowRight':
      return 'next';
    case 'e':
    case 'E':
      return 'exclude';
    default:
      return null;
  }
};
